module.exports = __webpack_public_path__ + "static/media/BAckgroundOfferBody.749c0240.png";